import { render, staticRenderFns } from "./OrderFlashAttachments.vue?vue&type=template&id=682deea8&scoped=true"
import script from "./OrderFlashAttachments.vue?vue&type=script&lang=js"
export * from "./OrderFlashAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682deea8",
  null
  
)

export default component.exports